<template>
  <div>
    <ul class="lista-downloads" v-if="acordos.length>0">
      <a name="listaAR"></a><li class="prod">Acordos Operacionais entre AR's</li>

      <li v-for="acordo in acordos">
        <a>{{ ars[acordo.ar1].nome }} - {{ ars[acordo.ar2].nome }}</a>
        <span>
          Período: {{ acordo.periodo.inicio }} a {{ acordo.periodo.fim }}.
          <em v-if="ars[acordo.ar1].descredenciada || ars[acordo.ar2].descredenciada">
            <br>(acordo encerrado no descredenciamento)
          </em>
        </span>
      </li>

    </ul>
  </div>
</template>

<script>
import { EventBus } from '../main';

export default {
  props: [
    'acselecionada'
  ],
  computed: {
    acordos() {
      //console.log('Computed: RepositorioAcordo acordos');
      /**
        Preparar Array com os acordos operacionais para o v-for
        Listar apenas as ARs credenciadas na AC selecionada
      */
      const resultArray = [];
      for( let key in EventBus.acordos ) {
        const item = EventBus.acordos[key];
        item._key = key;

        // Verificar se o acordo vale para a AC selecioanda
        if( !Array.isArray(item.ac) ) {
          console.log("ERRO: Acordo sem AC " + item._key );
        } else if( item.ac.indexOf( this.acselecionada ) >= 0 ) {

          // Filtrar pelo nome da AR
          if( EventBus.nomeAR != '' &&
            this.ars[item.ar1].nome.toLowerCase().indexOf(EventBus.nomeAR.toLowerCase()) == -1 &&
            this.ars[item.ar2].nome.toLowerCase().indexOf(EventBus.nomeAR.toLowerCase()) == -1
          ) {
            continue;
          }
          resultArray.push( item );

          // Verificar se as AR's estão credenciadas na AC selecionada
          if( this.ars[item.ar1].ac.indexOf( this.acselecionada ) < 0 || this.ars[item.ar2].ac.indexOf( this.acselecionada ) < 0 ) {
            console.log("AOP AR não credenciada: " + this.ars[item.ar1].nome + " - " + this.ars[item.ar2].nome);
          }

        }
      }
      return resultArray;
    },
    acs() {
      //console.log('Computed: RepositorioAcordo acs');
      return EventBus.acs;
    },
    ars() {
      //console.log('Computed: RepositorioAcordo ars');
      return EventBus.ars;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// RepositorioAcordo.vue?8feb9982